var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"text-center"},[_c('v-col',{staticClass:"mb-4"},[_c('h2',{staticClass:"display-1 font-weight-bold mb-1"},[_vm._v(" Search for Event ")])])],1),_c('SearchEvent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }